import { CryptoEventViewModel, CryptoGuess } from "@/event-core/types";
import { calc, get } from "@/utils/utils";
import { useCallback, useEffect, useState } from "react";
import { fetchCryptoGuessPage } from "../api";

export function useGuessList( data: CryptoEventViewModel ) {
    const [ guessList, setGuessList ] = useState<CryptoGuess[]>( data.guessList || [] );

    useEffect( () => {
        setGuessList( data.guessList || [] );
    }, [ data.guessList ] );

    const updateGuessList = useCallback( async () => {
        const eventNo = get( data, "eventNo", "" );
        const scheduleType = get( data.eventData, "scheduleType", "" );
        if ( !eventNo || guessList.length === 0 ) return;

        const mainGuessIndex = guessList.findIndex( ( g ) => get( g, "mainFlag", 0 ) === 1 );
        const firstId = Number( get( guessList[0], "id", 0 ) );
        const size = scheduleType === "MINUTE" ? 11 : 1;

        try {
            if ( mainGuessIndex > 0 ) {
                // 如果主竞猜不在第一位，以第一项 id - 1 为基准全量覆盖，确保第一项不丢失且主竞猜得到更新
                const result = await fetchCryptoGuessPage( {
                    eventNo,
                    direction: false,
                    id: Number( calc( "firstId - 1", { firstId } ) ),
                    size,
                } );
                if ( result.guessList.length > 0 ) {
                    setGuessList( result.guessList );
                }
            } else if ( mainGuessIndex === 0 ) {
                // 如果主竞猜在第一位，正向查询会漏掉它，故使用反向查询（id + 1）来获取它并局部更新
                const result = await fetchCryptoGuessPage( {
                    eventNo,
                    direction: true,
                    id: Number( calc( "firstId + 1", { firstId } ) ),
                    size: 1,
                } );
                if ( result.guessList.length > 0 ) {
                    const latestMain = result.guessList[0];
                    setGuessList( ( prev ) =>
                        prev.map( (
                            g,
                        ) => ( get( g, "guessNo", "" ) === get( latestMain, "guessNo", "" ) ? latestMain : g ) )
                    );
                }
            }
        } catch ( error ) {
            console.error( "Failed to update guessList:", error );
        }
    }, [ data, guessList ] );

    return {
        guessList,
        updateGuessList,
    };
}
